import React, {useContext, useEffect, useState} from "react";
import { TimepickerUI, PluginRegistry } from 'timepicker-ui';
import { WheelPlugin } from "timepicker-ui/plugins/wheel";
import moment from "moment";
import StringTools from "../../../../class/tool/StringTools";
import BackofficeContext from "../../../../context/BackofficeContext";
import "timepicker-ui/main.css";
import "timepicker-ui/theme-dark.css";
import "../../../../css/form/InputDateTimeSlot.css";
import "moment/locale/fr";

const InputDatetimeSlot = props => {
    PluginRegistry.register(WheelPlugin);
    moment.locale('fr');

    const { attribute, returnType, classname, value, handleChange } = props;
    const { setBubbleText, setEvent } = useContext(BackofficeContext);
    const [ typeSelected, setTypeSelected ] = useState("simple");
    const [ sDays, setSDays ] = useState({});
    const [ sTPStart1, setSTPStart1 ] = useState("8:00");
    const [ sTPEnd1, setSTPEnd1 ] = useState("19:00");
    const [ sTPStart2, setSTPStart2 ] = useState(null);
    const [ sTPEnd2, setSTPEnd2 ] = useState(null);
    const [ sTPErr1, setSTPErr1 ] = useState(null);
    const [ sTPErr2, setSTPErr2 ] = useState(null);
    const [ cTPHours, setCTPHours ] = useState({
        lun: [],
        mar: [],
        mer: [],
        jeu: [],
        ven: [],
        sam: [],
        dim: []
    });
    const [ cTPErr, setCTPErr ] = useState({
        lun: {0: null, 1: null},
        mar: {0: null, 1: null},
        mer: {0: null, 1: null},
        jeu: {0: null, 1: null},
        ven: {0: null, 1: null},
        sam: {0: null, 1: null},
        dim: {0: null, 1: null}
    });
    const days = [ "lun", "mar", "mer", "jeu", "ven", "sam", "dim" ];
    const dictDays = { lun: "lundi", mar: "mardi", mer: "mercredi", jeu: "jeudi", ven: "vendredi", sam: "samedi", dim: "dimanche" };

    const init = () => {
        const options = {
            ui: {
                theme: 'dark',
                mode: 'wheel',
                animation: true,
                backdrop: true
            },
            clock: {
                type: '24h',
                incrementMinutes: 15
            },
            labels: {
                ok: "Valider",
                cancel: "Fermer",
                time: "Sélectionner l'heure",
                mobileTime: "Sélectionner l'heure",
                mobileHour: "Heure",
                mobileMinute: "Minute"
            }
        };
        const sTimePickerStart1 = new TimepickerUI(document.querySelector("#sTimePickerStart1"), options);
        const sTimePickerEnd1 = new TimepickerUI(document.querySelector("#sTimePickerEnd1"), options);
        const sTimePickerStart2 = new TimepickerUI(document.querySelector("#sTimePickerStart2"), options);
        const sTimePickerEnd2 = new TimepickerUI(document.querySelector("#sTimePickerEnd2"), options);

        sTimePickerStart1.on("confirm", (data) => { setSTPStart1(data.hour + ":" + data.minutes); });
        sTimePickerEnd1.on("confirm", (data) => { setSTPEnd1(data.hour + ":" + data.minutes); });
        sTimePickerStart2.on("confirm", (data) => { setSTPStart2(data.hour + ":" + data.minutes); });
        sTimePickerEnd2.on("confirm", (data) => { setSTPEnd2(data.hour + ":" + data.minutes); });

        sTimePickerStart1.create();
        sTimePickerEnd1.create();
        sTimePickerStart2.create();
        sTimePickerEnd2.create();

        let cTPS1, cTPE1, cTPS2, cTPE2;

        for (let i in days) {
            cTPS1 = new TimepickerUI(document.querySelector("#cTimePickerStart1-" + days[i]), options);
            cTPE1 = new TimepickerUI(document.querySelector("#cTimePickerEnd1-" + days[i]), options);
            cTPS2 = new TimepickerUI(document.querySelector("#cTimePickerStart2-" + days[i]), options);
            cTPE2 = new TimepickerUI(document.querySelector("#cTimePickerEnd2-" + days[i]), options);

            cTPS1.on("confirm", (data) => { setCTP(days[i], 0, "start", data); });
            cTPE1.on("confirm", (data) => { setCTP(days[i], 0, "end", data); });
            cTPS2.on("confirm", (data) => { setCTP(days[i], 1, "start", data); });
            cTPE2.on("confirm", (data) => { setCTP(days[i], 1, "end", data); });

            cTPS1.create();
            cTPE1.create();
            cTPS2.create();
            cTPE2.create();
        }
    }
    const explodeValue = () => {
        let val = defineValue();

        if (val === null || val.type === undefined || val.type === null)
            return;

        try {
            setTypeSelected(val.type);

            switch (val.type) {
                case "simple":
                    setSDays(val.days);
                    setSTPStart1(val.hours[0].start.h + ":" + (val.hours[0].start.m === 0 ? "0" : "") + val.hours[0].start.m);
                    setSTPEnd1(val.hours[0].end.h + ":" + (val.hours[0].start.m === 0 ? "0" : "") + val.hours[0].start.m);

                    if (val.hours.length > 1) {
                        setSTPStart2(val.hours[1].start.h + ":" + (val.hours[1].start.m === 0 ? "0" : "") + val.hours[1].start.m);
                        setSTPEnd2(val.hours[1].end.h + ":" + (val.hours[1].start.m === 0 ? "0" : "") + val.hours[1].start.m);
                    }

                    break;
                case "custom":
                    // Default values for simple
                    setSDays({
                        lun: true,
                        mar: true,
                        mer: true,
                        jeu: true,
                        ven: true,
                        sam: true,
                        dim: false
                    });
                    setSTPStart1("6:00");
                    setSTPEnd1("19:00");

                    let TPHours = {};

                    for (let i in val.days) {
                        TPHours[i] = [];

                        for (let j in val.days[i]) {
                            TPHours[i].push({
                                start: val.days[i][j].start.h + ":" + (val.days[i][j].start.m === 0 ? "0" : "") + val.days[i][j].start.m,
                                end: val.days[i][j].end.h + ":" + (val.days[i][j].end.m === 0 ? "0" : "") + val.days[i][j].end.m
                            });
                        }
                    }

                    setCTPHours(TPHours);

                    break;
                default: break;
            }
        }
        catch (e) {
            console.error("InputDatetimeSlot.explodeValue", e);
        }
    }
    const defineValue = () => {
        if (value.length > 0)
            return JSON.parse(value);
        else {
            return {
                type: "simple",
                days: {
                    lun: true,
                    mar: true,
                    mer: true,
                    jeu: true,
                    ven: true,
                    sam: true,
                    dim: false
                },
                hours: [
                    {
                        start: { h: "6", m: "00" },
                        end: { h: "19", m: "00" }
                    }
                ]
            }
        }
    }
    const setCTP = (day, index, type, data) => {
        try {
            let cTPHoursTmp = Object.assign({}, cTPHours);
            cTPHoursTmp[day][index][type] = data.hour + ":" + data.minutes;
            setCTPHours(cTPHoursTmp);
        }
        catch (e) {
            console.error("setCTP", e);
        }
    }
    const selectSDay = day => {
        let tmpSDays = Object.assign({}, sDays);
        tmpSDays[day] = !tmpSDays[day];
        setSDays(tmpSDays);
    }
    const detailsSDays = () => {
        if (sDays.lun && sDays.mar && sDays.mer && sDays.jeu && sDays.ven && !sDays.sam && !sDays.dim)
            return "Jours de la semaine";
        else if (sDays.lun && sDays.mar && sDays.mer && sDays.jeu && sDays.ven && sDays.sam && sDays.dim)
            return "Tous les jours";
        else if (!sDays.lun && !sDays.mar && !sDays.mer && !sDays.jeu && !sDays.ven && !sDays.sam && !sDays.dim)
            return "Aucun jour";
        else {
            let count = 0;
            let keys = Object.keys(sDays);
            let base = sDays.lun;
            let change = 0;

            for (let i in keys) {
                if (base !== sDays[keys[i]]) {
                    if (!sDays[keys[i]] || (sDays[keys[i]] && change > 0))
                        change++;
                }

                if (sDays[keys[i]])
                    count++;

                base = sDays[keys[i]];
            }

            if (change < 2) {
                let first = "";
                let last = "";

                for (let i in keys) {
                    if (sDays[keys[i]]) {
                        if (first.length === 0)
                            first = dictDays[keys[i]];
                        else
                            last = dictDays[keys[i]];
                    }
                }

                if (count === 1)
                    return "Le " + first;
                else
                    return "Du " + first + " au " + last;
            }
            else
                return count + " jour" + (count > 1 ? "s" : "");
        }
    }
    const detailsSHours = () => {
        try {
            let count = 0;

            const explStart1 = sTPStart1.split(":");
            const explEnd1 = sTPEnd1.split(":");
            const mSTPStart1 = moment().set({hour:parseInt(explStart1[0]), minute:parseInt(explStart1[1]), second:0, millisecond:0});
            const mSTPEnd1 = moment().set({hour:parseInt(explEnd1[0]), minute:parseInt(explEnd1[1]), second:0, millisecond:0});

            if (parseInt(explEnd1[0]) < 7)
                mSTPEnd1.add(1, "days");

            count += Math.abs(mSTPStart1.diff(mSTPEnd1, 'hours'));

            if (sTPStart2 !== null && sTPEnd2 !== null) {
                const explStart2 = sTPStart2.split(":");
                const explEnd2 = sTPEnd2.split(":");
                const mSTPStart2 = moment().set({hour:parseInt(explStart2[0]), minute:parseInt(explStart2[1]), second:0, millisecond:0});
                const mSTPEnd2 = moment().set({hour:parseInt(explEnd2[0]), minute:parseInt(explEnd2[1]), second:0, millisecond:0});

                if (parseInt(explEnd2[0]) < 7)
                    mSTPEnd2.add(1, "days");

                count += Math.abs(mSTPStart2.diff(mSTPEnd2, 'hours'));
            }

            return count + " heure" + (count > 1 ? "s" : "");
        }
        catch (e) {
            console.error("detailsSHours ", e);
        }
    }
    const detailsCHours = day => {
        try {
            let count = 0;

            if (cTPHours[day].length > 0) {
                const explStart1 = cTPHours[day][0].start.split(":");
                const explEnd1 = cTPHours[day][0].end.split(":");
                const mSTPStart1 = moment().set({hour:parseInt(explStart1[0]), minute:parseInt(explStart1[1]), second:0, millisecond:0});
                const mSTPEnd1 = moment().set({hour:parseInt(explEnd1[0]), minute:parseInt(explEnd1[1]), second:0, millisecond:0});

                if (parseInt(explEnd1[0]) < 7)
                    mSTPEnd1.add(1, "days");

                count += Math.abs(mSTPStart1.diff(mSTPEnd1, 'hours'));

                if (cTPHours[day].length > 1 && cTPHours[day][1].start !== null && cTPHours[day][1].end !== null) {
                    const explStart2 = cTPHours[day][1].start.split(":");
                    const explEnd2 = cTPHours[day][1].end.split(":");
                    const mSTPStart2 = moment().set({hour:parseInt(explStart2[0]), minute:parseInt(explStart2[1]), second:0, millisecond:0});
                    const mSTPEnd2 = moment().set({hour:parseInt(explEnd2[0]), minute:parseInt(explEnd2[1]), second:0, millisecond:0});

                    if (parseInt(explEnd2[0]) < 7)
                        mSTPEnd2.add(1, "days");

                    count += Math.abs(mSTPStart2.diff(mSTPEnd2, 'hours'));
                }
            }

            if (count === 0)
                return "Fermé";
            else
                return count + " heure" + (count > 1 ? "s" : "");
        }
        catch (e) {
            console.error("detailsCHours ", e);
        }
    }
    const addSlot = (type, day = null) => {
        switch (type) {
            case "simple":
                setSTPStart2(sTPEnd1);
                setSTPEnd2("20:00");
                break;
            case "custom":
                let cTPHoursTmp = Object.assign({}, cTPHours);

                if (cTPHoursTmp[day].length < 2) {
                    if (cTPHoursTmp[day].length === 0)
                        cTPHoursTmp[day].push({ start: "6:00", end: "19:00"});
                    else
                        cTPHoursTmp[day].push({ start: cTPHoursTmp[day][0].end, end: "20:00"});
                }

                setCTPHours(cTPHoursTmp);

                break;
            default: break;
        }
    }
    const removeSlot = (type, day = null) => {
        switch (type) {
            case "simple":
                setSTPStart2(null);
                setSTPEnd2(null);
                break;
            case "custom":
                let cTPHoursTmp = Object.assign({}, cTPHours);

                if (cTPHoursTmp[day].length > 0)
                    cTPHoursTmp[day].splice(-1);

                setCTPHours(cTPHoursTmp);

                break;
            default: break;
        }
    }
    const controlSTP1 = () => {
        try {
            const explStart1 = sTPStart1.split(":");
            const explEnd1 = sTPEnd1.split(":");
            const mSTPStart1 = moment().set({hour:parseInt(explStart1[0]), minute:parseInt(explStart1[1]), second:0, millisecond:0});
            const mSTPEnd1 = moment().set({hour:parseInt(explEnd1[0]), minute:parseInt(explEnd1[1]), second:0, millisecond:0});

            if (parseInt(explEnd1[0]) < 7)
                mSTPEnd1.add(1, "days");

            if (mSTPStart1.isAfter(mSTPEnd1)) {
                const err = "L'horaire de fermeture ne peut pas être avant l'horaire d'ouverture";
                setSTPErr1(err);
                setEvent({
                    type: "error",
                    text: err
                });
            }
            else
                setSTPErr1(null);
        }
        catch (e) {
            console.error("controlSTP 1", e);
        }
    }
    const controlSTP2 = () => {
        if (sTPStart2 !== null && sTPEnd2 !== null) {
            try {
                const explStart2 = sTPStart2.split(":");
                const explEnd2 = sTPEnd2.split(":");
                const mSTPStart2 = moment().set({hour:parseInt(explStart2[0]), minute:parseInt(explStart2[1]), second:0, millisecond:0});
                const mSTPEnd2 = moment().set({hour:parseInt(explEnd2[0]), minute:parseInt(explEnd2[1]), second:0, millisecond:0});

                if (parseInt(explEnd2[0]) < 7)
                    mSTPEnd2.add(1, "days");

                if (mSTPStart2.isAfter(mSTPEnd2)) {
                    const err = "L'horaire de fermeture ne peut pas être avant l'horaire d'ouverture";
                    setSTPErr2(err);
                    setEvent({
                        type: "error",
                        text: err
                    });
                }
                else
                    setSTPErr2(null);
            }
            catch (e) {
                console.error("controlSTP 2", e);
            }
        }
    }
    const controlCTP = () => {
        try {
            let explStart, explEnd, mCTPStart, mCTPEnd;
            let cTPErrTmp = Object.assign({}, cTPErr);
            let hasError = false;

            for (let i in days) {
                for (let j = 0; j < cTPHours[days[i]].length; j++) {
                    if (cTPHours[days[i]][j] === null)
                        continue;

                    explStart = cTPHours[days[i]][j].start.split(":");
                    explEnd = cTPHours[days[i]][j].end.split(":");
                    mCTPStart = moment().set({hour:parseInt(explStart[0]), minute:parseInt(explStart[1]), second:0, millisecond:0});
                    mCTPEnd = moment().set({hour:parseInt(explEnd[0]), minute:parseInt(explEnd[1]), second:0, millisecond:0});

                    if (parseInt(explEnd[0]) < 7)
                        mCTPEnd.add(1, "days");

                    if (mCTPStart.isAfter(mCTPEnd)) {
                        cTPErrTmp[days[i]][j] = "L'horaire de fermeture ne peut pas être avant l'horaire d'ouverture";
                        hasError = true;
                    }
                    else
                        cTPErrTmp[days[i]][j] = null;
                }
            }

            setCTPErr(cTPErrTmp);

            if (hasError){
                setEvent({
                    type: "error",
                    text: "L'horaire de fermeture ne peut pas être avant l'horaire d'ouverture"
                });
            }
        }
        catch (e) {
            console.error("controlCTP", e);
        }
    }
    const change = () => {
        if (handleChange === undefined || handleChange === null)
            return;

        let value = buildValue();

        if (value.length > 0) {
            handleChange(attribute, returnType, value);
        }
    }
    const buildValue = () => {
        let datas, explStart1, explEnd1, explStart2, explEnd2;

        switch (typeSelected) {
            case "simple":
                explStart1 = sTPStart1.split(":");
                explEnd1 = sTPEnd1.split(":");

                let hours = [{
                    start: { h: parseInt(explStart1[0]), m: parseInt(explStart1[1]) },
                    end: { h: parseInt(explEnd1[0]), m: parseInt(explEnd1[1]) }
                }];

                if (sTPStart1 !== null && sTPStart2 !== null) {
                    explStart2 = sTPStart2.split(":");
                    explEnd2 = sTPEnd2.split(":");

                    hours.push({
                        start: { h: parseInt(explStart2[0]), m: parseInt(explStart2[1]) },
                        end: { h: parseInt(explEnd2[0]), m: parseInt(explEnd2[1]) }
                    });
                }

                datas = {
                    type: "simple",
                    days: sDays,
                    hours: hours
                };

                return JSON.stringify(datas);
            case "custom":
                let listDays = {};

                for (let i in cTPHours) {
                    listDays[i] = [];

                    for (let j in cTPHours[i]) {
                        explStart1 = cTPHours[i][j].start.split(":");
                        explEnd1 = cTPHours[i][j].end.split(":");

                        listDays[i].push({
                            start: { h: parseInt(explStart1[0]), m: parseInt(explStart1[1]) },
                            end: { h: parseInt(explEnd1[0]), m: parseInt(explEnd1[1]) }
                        });
                    }
                }

                datas = {
                    type: "custom",
                    days: listDays
                };

                return JSON.stringify(datas);
            default: return "";
        }
    }

    useEffect(() => {
        init();
        explodeValue();
    }, []);
    useEffect(() => {
        controlSTP1();
    }, [sTPStart1, sTPEnd1]);
    useEffect(() => {
        controlSTP2();
    }, [sTPStart2, sTPEnd2]);
    useEffect(() => {
        controlCTP();
    }, [cTPHours]);
    useEffect(() => {
        change();
    }, [typeSelected, sDays, sTPStart1, sTPEnd1, sTPStart2, sTPEnd2, cTPHours]);

    return (
        <div className={ "inputDatetimeSlot" + (classname !== undefined ? " " + classname : "") }>
            <div className={"datetimePart" + (typeSelected === "simple" ? " selected" : "")}>
                <div className={"headerPart"} onClick={() => { setTypeSelected("simple") }}>
                    <div className={"puce"} />
                    <p>Simple</p>
                </div>
                <div className={"onPart"}>
                    <div className={"titleDetails"}>
                        <p>Jours d'ouverture</p>
                        <p className={"details"}>- { detailsSDays() }</p>
                    </div>
                    <div className={"days"}>
                        {
                            days.map((day, index) => (
                                <p
                                    key={index}
                                    className={"day " + day + (sDays[day] !== undefined && sDays[day] ? " selected" : "")}
                                    onClick={() => { selectSDay(day) }}>
                                    { StringTools.capitalizeFirstLetter(day) }
                                </p>
                            ))
                        }
                    </div>
                </div>
                <div className={"hoursPart"}>
                    <div className={"titleDetails"}>
                        <p>Horaires</p>
                        <p className={"details"}>- { detailsSHours() }</p>
                    </div>
                    <div className={"hours"}>
                        <div
                            className={"slots" + (sTPErr1 !== null ? " err" : "")}
                            onMouseOver={(sTPErr1 !== null ? () => { setBubbleText(sTPErr1) } : ()=>{})}
                            onMouseOut={() => { setBubbleText(null) }}>
                            <p className={"sep"}>De</p>
                            <input id={"sTimePickerStart1"} className={"slot"} type={"text"} value={sTPStart1} />
                            <p className={"sep"}>à</p>
                            <input id={"sTimePickerEnd1"} className={"slot"} type={"text"} value={sTPEnd1} />
                        </div>
                        <div
                            className={"slots margin" + (sTPStart2 === null || sTPEnd2 === null ? " hidden" : "") + (sTPErr2 !== null ? " err" : "")}
                            onMouseOver={(sTPErr2 !== null ? () => { setBubbleText(sTPErr2) } : ()=>{})}
                            onMouseOut={() => { setBubbleText(null) }}>
                            <p className={"sep"}>De</p>
                            <input id={"sTimePickerStart2"} className={"slot"} type={"text"} value={sTPStart2} />
                            <p className={"sep"}>à</p>
                            <input id={"sTimePickerEnd2"} className={"slot"} type={"text"} value={sTPEnd2} />
                            <p className={"addSlot"} onClick={() => { removeSlot("simple"); }}>Suppr.</p>
                        </div>
                        <p className={"addSlot add" + (sTPStart2 !== null && sTPEnd2 !== null ? " hidden" : "")} onClick={() => { addSlot("simple"); }}>Ajouter un créneau</p>
                    </div>
                </div>
            </div>
            <div className={"datetimePart" + (typeSelected === "custom" ? " selected" : "")}>
                <div className={"headerPart"} onClick={() => { setTypeSelected("custom") }}>
                    <div className={"puce"} />
                    <p>Personnalisé</p>
                </div>
                <div className={"onPart"}>
                    <div className={"cDays"}>
                        {
                            days.map((day, index) => (
                                <div key={index} className={"day"}>
                                    <p className={"titleDay" + (index > 0 ? " margin" : "")}>{ StringTools.capitalizeFirstLetter(dictDays[day]) }<span>- { detailsCHours(day) }</span></p>
                                    <div className={"hoursPart minMargin"}>
                                        <div className={"hours"}>
                                            <div
                                                className={"slots" + (cTPHours[day].length === 0 ? " hidden" : "") + (cTPErr[day][0] !== null ? " err" : "")}
                                                onMouseOver={(cTPErr[day][0] !== null ? () => { setBubbleText(cTPErr[day][0]) } : ()=>{})}
                                                onMouseOut={() => { setBubbleText(null) }}>
                                                <p className={"sep"}>De</p>
                                                <input id={"cTimePickerStart1-" + day} className={"slot"} type={"text"} value={cTPHours[day].length > 0 ? cTPHours[day][0].start : ""} />
                                                <p className={"sep"}>à</p>
                                                <input id={"cTimePickerEnd1-" + day} className={"slot"} type={"text"} value={cTPHours[day].length > 0 ? cTPHours[day][0].end : ""} />
                                                {
                                                    cTPHours[day].length === 1 && <p className={"addSlot"} onClick={() => { removeSlot("custom", day); }}>Suppr.</p>
                                                }
                                            </div>
                                            <div
                                                className={"slots margin" + (cTPHours[day].length < 2 ? " hidden" : "") + (cTPErr[day][1] !== null ? " err" : "")}
                                                onMouseOver={(cTPErr[day][1] !== null ? () => { setBubbleText(cTPErr[day][1]) } : ()=>{})}
                                                onMouseOut={() => { setBubbleText(null) }}>
                                                <p className={"sep"}>De</p>
                                                <input id={"cTimePickerStart2-" + day} className={"slot"} type={"text"} value={cTPHours[day].length > 1 ? cTPHours[day][1].start : ""} />
                                                <p className={"sep"}>à</p>
                                                <input id={"cTimePickerEnd2-" + day} className={"slot"} type={"text"} value={cTPHours[day].length > 1 ? cTPHours[day][1].end : ""} />
                                                <p className={"addSlot"} onClick={() => { removeSlot("custom", day); }}>Suppr.</p>
                                            </div>
                                            <p className={"addSlot add" + (cTPHours[day].length === 2 ? " hidden" : "")} onClick={() => { addSlot("custom", day); }}>Ajouter un créneau</p>
                                        </div>
                                    </div>
                                </div>
                            ))
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

export default InputDatetimeSlot;